<div [matTooltip]="'Upload image'" [matTooltipPosition]="'before'">
  <button
    mat-icon-button
    [class.active]="active"
    [y42Permission]="state.isCanvasEditable"
    [permissionTooltip]="'You do not have permission to edit the asset'"
    [intercomTarget]="'toolbar-insert-image'"
    (click)="cropImageHelper.trigger()"
  >
    <y42-image-crop #cropImageHelper [imageFormCtrl]="imageFormControl"></y42-image-crop>
    <fa-icon [icon]="['fal', 'image']"></fa-icon>
  </button>
</div>
